import React from 'react';
import { AlbumVariationView } from '@zola/svc-web-api-ts-client';
// Components
import Modal, { ModalV2Props } from '@zola/zola-ui/src/components/Modal/ModalV2';
import ModalContent from '@zola/zola-ui/src/components/Modal/ModalContent';
import PricingMatrix from './PricingMatrix';

type PricingBreakdownModalProps = {
  onClose: ModalV2Props['onClose'];
  triggerRef: ModalV2Props['triggerRef'];
  matrixData: Record<string, Array<AlbumVariationView>>;
};

const PricingBreakdownModal = ({
  triggerRef,
  onClose,
  matrixData,
}: PricingBreakdownModalProps): JSX.Element => {
  return (
    <Modal
      dialogHeadingId="pricing-breakdown"
      onClose={onClose}
      rootId="portal-root"
      triggerRef={triggerRef}
      lockBgScrolling
    >
      <ModalContent stickyHeader>
        <PricingMatrix matrixData={matrixData} />
      </ModalContent>
    </Modal>
  );
};

export default PricingBreakdownModal;
